/**
 * Masks a bank account number (e.g., "12345678" -> "****5678")
 */
export function maskAccountNumber(accountNumber: string | null): string {
  if (!accountNumber) return '--';
  if (accountNumber.length <= 4) return accountNumber;
  return '****' + accountNumber.slice(-4);
}

/**
 * Masks a sort code (e.g., "12-34-56" or "123456" -> "**-**-56")
 */
export function maskSortCode(sortCode: string | null): string {
  if (!sortCode) return '--';
  const digits = sortCode.replace(/-/g, '');
  if (digits.length !== 6) return sortCode;
  return `**-**-${digits.slice(-2)}`;
}
